import Layout from '@/components/Layout'
import Seo from '@/components/Seo'
import { company } from '@/lib/site-data'

function PoliticaPrivacidade() {
  return (
    <Layout>
      <Seo
        title="Política de Privacidade | Muita Mídia"
        description="Política de Privacidade da Muita Mídia LTDA: como coletamos, usamos e protegemos os dados dos visitantes e clientes do site."
        path="/politica-de-privacidade"
      />

      <section className="bg-white">
        <div className="mx-auto max-w-3xl px-6 py-16 sm:py-20">
          <h1 className="text-3xl font-bold text-zinc-900">Política de Privacidade</h1>
          <p className="mt-3 text-sm text-zinc-500">Última atualização: janeiro de 2024</p>

          <div className="mt-8 space-y-8 text-base leading-relaxed text-zinc-700">
            <div>
              <h2 className="text-lg font-semibold text-zinc-900">1. Quem somos</h2>
              <p className="mt-2">
                Este site é operado por {company.legalName}, inscrita no CNPJ {company.cnpj}, com sede em {company.address}.
                Esta Política de Privacidade explica como tratamos as informações de quem visita nosso site ou entra em contato
                pelo WhatsApp para comprar uma página do Instagram.
              </p>
            </div>
            <div>
              <h2 className="text-lg font-semibold text-zinc-900">2. Quais dados coletamos</h2>
              <p className="mt-2">
                Não operamos formulários de cadastro ou checkout neste site. As informações pessoais que tratamos, como nome,
                número de telefone e preferências de compra, são fornecidas diretamente por você durante a conversa no WhatsApp,
                de forma voluntária, para viabilizar o atendimento e a venda.
              </p>
            </div>
            <div>
              <h2 className="text-lg font-semibold text-zinc-900">3. Como usamos os dados</h2>
              <p className="mt-2">
                Utilizamos os dados fornecidos exclusivamente para: (i) responder dúvidas sobre nossos serviços; (ii) processar
                pagamentos e formalizar a venda de uma página do Instagram; (iii) realizar a transferência assistida do perfil;
                (iv) prestar suporte pós-venda; e (v) cumprir obrigações legais e fiscais.
              </p>
            </div>
            <div>
              <h2 className="text-lg font-semibold text-zinc-900">4. Compartilhamento de dados</h2>
              <p className="mt-2">
                Não vendemos nem compartilhamos seus dados pessoais com terceiros para fins de marketing. Dados podem ser
                compartilhados apenas quando exigido por lei, por ordem judicial, ou com prestadores de serviço estritamente
                necessários para viabilizar o pagamento e a entrega da página adquirida.
              </p>
            </div>
            <div>
              <h2 className="text-lg font-semibold text-zinc-900">5. Segurança da informação</h2>
              <p className="mt-2">
                Adotamos medidas técnicas e organizacionais razoáveis para proteger as informações trocadas durante o
                atendimento e o processo de transferência de propriedade das páginas vendidas.
              </p>
            </div>
            <div>
              <h2 className="text-lg font-semibold text-zinc-900">6. Seus direitos</h2>
              <p className="mt-2">
                Você pode, a qualquer momento, solicitar informações sobre os dados que tratamos a seu respeito, corrigi-los
                ou solicitar sua exclusão, respeitadas as obrigações legais de guarda de documentos fiscais. Basta entrar em
                contato pelo nosso WhatsApp.
              </p>
            </div>
            <div>
              <h2 className="text-lg font-semibold text-zinc-900">7. Alterações desta política</h2>
              <p className="mt-2">
                Esta Política de Privacidade pode ser atualizada periodicamente para refletir melhorias em nossos processos
                ou exigências legais. Recomendamos a consulta periódica desta página.
              </p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default PoliticaPrivacidade
